import { render, staticRenderFns } from "./VLottie.vue?vue&type=template&id=0cee4812"
import script from "./VLottie.vue?vue&type=script&lang=js"
export * from "./VLottie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports